import {
  Button,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { HiMenu } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useAuth from "../../hooks/useAuth";

import zainLogo from "../../assets/images/zain-logo.svg";
import Searchbar from "./Searchbar";
import useAxios from "../../hooks/useAxios";
import { subscribe } from "../../config/axios";

const drawerWidth = 240;

export default function MenuButton({ window }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, token, phoneNumber } = useAuth();
  const axios = useAxios();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCancelSubscription = async () => {
    try {
      const response = await axios.post("unsubscribe", { phoneNumber });
      if (response.data.success) {
        toast.success("تم إلغاء الاشتراك بنجاح");
        logout();
      }
    } catch (error) {}
  };

  const container = window !== undefined ? window().document.body : undefined;
  return (
    <>
      <IconButton
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mx: 1, color: "white" }}
      >
        <HiMenu fontSize={27} />
      </IconButton>
      <Drawer
        container={container}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: "block",
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        <Stack my={5} mx="auto" width="90%" alignContent="center">
          <Typography variant="h4" fontWeight={700} my={2} textAlign="center">
            قانوني
          </Typography>

          {/* <TextField
            sx={{ flexGrow: 1, my: 2 }}
            color="primary"
            size="small"
            variant="outlined"
            placeholder="البحث"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end">
                    <AiOutlineSearch />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}

          <Searchbar sx={{ flexGrow: 1, my: 2 }} />

          <Divider sx={{ my: 3 }} />

          <Stack
            sx={{
              display: "flex",
            }}
            flexDirection="column"
            gap={1}
            alignItems="center"
          >
            <Typography variant="caption" textAlign="center" mb={1}>
              {token
                ? "كل ما تحتاجه من إستشارات قانونية الان في متناول يدك"
                : "اشترك لتتمكن من مشاهدة مجموعة رائعة من مقاطع الفيديو"}
            </Typography>
            {!token ? (
              <a
                href={subscribe}
                style={{ textDecoration: "none", width: "100%" }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  // onClick={() => navigate("/subscribe")}
                >
                  الإشتراك
                </Button>
              </a>
            ) : (
              <Button
                fullWidth
                variant="contained"
                onClick={handleCancelSubscription}
              >
                إلغاء الاشتراك
              </Button>
            )}
            {!token ? (
              <Button
                fullWidth
                onClick={() => navigate("/login")}
                variant="outlined"
              >
                تسجيل الدخول
              </Button>
            ) : (
              <Button fullWidth onClick={logout} variant="outlined">
                تسجيل الخروج
              </Button>
            )}
          </Stack>

          <Divider sx={{ my: 2 }} />

          <img
            src={zainLogo}
            alt=""
            style={{ maxHeight: "7rem", objectFit: "contain" }}
          />
        </Stack>
      </Drawer>
    </>
  );
}
